// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.media_attachment_type_enum */
var MediaAttachmentTypeEnum;
(function (MediaAttachmentTypeEnum) {
    MediaAttachmentTypeEnum["IMAGE"] = "IMAGE";
    MediaAttachmentTypeEnum["VIDEO"] = "VIDEO";
    MediaAttachmentTypeEnum["DOCUMENT"] = "DOCUMENT";
})(MediaAttachmentTypeEnum || (MediaAttachmentTypeEnum = {}));
;
export default MediaAttachmentTypeEnum;
/** Zod schema for media_attachment_type_enum */
export const mediaAttachmentTypeEnum = z.nativeEnum(MediaAttachmentTypeEnum);
//# sourceMappingURL=MediaAttachmentTypeEnum.js.map